import React from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';

import BookAddToMyBooks from 'rebook/apps/books/components/BookStatusChangeButton/BookAddToMyBooks';
import BookOpenStatusChangePopup from 'rebook/apps/books/components/BookStatusChangeButton/BookOpenStatusChangePopup';

import styles from './style.scss';


class BookStatusChangeButton extends React.Component {
  constructor(props) {
    super(props);

    let isInstantAdd = false;

    if (__RENDER__ === 'client') {
      const { search } = location;
      const { isInstantAdd: isInstantAddParam } = queryString.parse(search);

      if (isInstantAddParam === 'true') {
        isInstantAdd = true;
      }
    }

    this.state = { readingStatus: this.props.readingStatus, isInstantAdd };
  }

  componentDidUpdate({ readingStatus }) {
    if (this.props.readingStatus !== readingStatus) {
      this.setState({ readingStatus: this.props.readingStatus });
    }
  }

  onChangeStatus(status) {
    this.setState({ readingStatus: status }, () => {
      this.props.onChangeStatus(status);
    });
  }


  componentDidMount() {
    if (this.props.readingStatus === 1) {
      this.afterInstantAdd();
    }
  }

  afterInstantAdd() {
    const { pathname, search } = location;
    const parsed = queryString.parse(search);

    delete parsed.isInstantAdd;

    window.history.replaceState(
      '',
      '',
      `${pathname}?${ queryString.stringify(parsed)}`,
    );

    this.setState({ isInstantAdd: false });
  }

  render() {
    const { user, bookId, bookTitle, bookType, bookDetail, book } = this.props;
    const { readingStatus, isInstantAdd } = this.state;

    return (
      <div className={styles.container}>
        {readingStatus
          ? (
            <BookOpenStatusChangePopup
              book={book}
              bookId={bookId}
              bookType={bookType}
              bookTitle={bookTitle}
              readingStatus={readingStatus}
              extraClassName={styles.button}
              onChangeStatus={(status) => this.onChangeStatus(status)}
              bookDetail={bookDetail}
              user={user} />
          )
          : (
            <BookAddToMyBooks
              book={book}
              bookId={bookId}
              bookType={bookType}
              bookTitle={bookTitle}
              extraClassName={styles.button}
              onChangeStatus={() => this.onChangeStatus(1)}
              isInstantAdd={isInstantAdd}
              afterInstantAdd={() => this.afterInstantAdd()}
              user={user} />
          )
        }
      </div>
    );
  }
}

BookStatusChangeButton.propTypes = {
  bookType: PropTypes.string,
  bookTitle: PropTypes.string,
  bookId: PropTypes.number,
  onChangeStatus: PropTypes.func,
};

BookStatusChangeButton.defaultProps = {
  bookType: 'text',
  readingStatus: 0,
  bookTitle: '',
  onChangeStatus: function () {
  },
};

export default BookStatusChangeButton;
